import React, { useState, useEffect } from 'react'
import Sidebar from '../mini-comp/Sidebar'
import Topbar from '../mini-comp/Topbar'
import axios from 'axios';
import Cookies from 'js-cookie';
import API_BASE_URL from '../../../config/api';
import { FaUsers, FaUserCog, FaSitemap, FaCalendarCheck, FaBell } from 'react-icons/fa'
import { RiEyeLine } from 'react-icons/ri'

const HRDashboard = () => {
    const [totalEmployees, setTotalEmployees] = useState(0);
    const [totalImmediateManagers, setTotalImmediateManagers] = useState(0);
    const [totalEmployeesOnLeave, setTotalEmployeesOnLeave] = useState(0);
    const [totalEmployeesSuspended, setTotalEmployeesSuspended] = useState(0);
    const [totalEmployeesTerminated, setTotalEmployeesTerminated] = useState(0);
    const [totalDepartments, setTotalDepartments] = useState(0);
    const [totalHolidays, setTotalHolidays] = useState(0)
    const [nextHoliday, setNextHoliday] = useState({})
    const [recentlyAddedEmployees, setRecentlyAddedEmployees] = useState([])
    const [recentNotices, setRecentNotices] = useState([])
    const [dashboardData, setDashboardData] = useState(null);

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        const options = { day: 'numeric', month: 'long', year: 'numeric' };
        return date.toLocaleDateString(undefined, options);
    };

    useEffect(() => {
        const token = Cookies.get('token');

        if (!token) {
            console.error('No token found in cookies');
            return;
        }

        axios.get(`${API_BASE_URL}/api/v1/employees/hr-dashboard/`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
            .then(response => {
                console.log(response.data);
                setTotalEmployees(response.data.total_employees);
                setTotalImmediateManagers(response.data.total_immediate_managers);
                setTotalEmployeesOnLeave(response.data.total_employees_on_leave);
                setTotalEmployeesSuspended(response.data.total_employees_suspended);
                setTotalEmployeesTerminated(response.data.total_employees_terminated);
                setTotalDepartments(response.data.total_departments);
                setRecentlyAddedEmployees(response.data.recently_added_employees);
                setTotalHolidays(response.data.total_holidays);
                setNextHoliday(response.data.next_holiday);
                setRecentNotices(response.data.recent_notices);
                setDashboardData(response.data);
            })
            .catch(error => {
                console.error('Error fetching admin dashboard data:', error);
            });
    }, []);

    return (
        <div>
            <Topbar />
            <Sidebar />

            <>{ /* app-content-area-start */}
                <div className="app-content-area">
                    <div className="app-content-wrap">
                        <div className="container-fluid">
                            <div className="row fix">
                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6">
                                    <div className="card">
                                        <div className="card-body mini-card-body d-flex align-center gap-16">
                                            <div className="avatar avatar-xl bg-primary-transparent text-primary">
                                                <FaUsers />
                                            </div>
                                            <div className="card-content">
                                                <span className="d-block fs-16 mb-5">Total Employees</span>
                                                <h2 className="mb-5">{totalEmployees}</h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6">
                                    <div className="card">
                                        <div className="card-body mini-card-body d-flex align-center gap-16">
                                            <div className="avatar avatar-xl bg-secondary-transparent text-secondary">
                                                <FaUserCog />
                                            </div>
                                            <div className="card-content">
                                                <span className="d-block fs-16 mb-5">Immediate Managers</span>
                                                <h2 className="mb-5">{totalImmediateManagers}</h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6">
                                    <div className="card">
                                        <div className="card-body mini-card-body d-flex align-center gap-16">
                                            <div className="avatar avatar-xl bg-primary-transparent text-primary">
                                                <FaSitemap />
                                            </div>
                                            <div className="card-content">
                                                <span className="d-block fs-16 mb-5">Total Departments</span>
                                                <h2 className="mb-5">{totalDepartments}</h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6">
                                    <div className="card">
                                        <div className="card-body mini-card-body d-flex align-center gap-16">
                                            <div className="avatar avatar-xl bg-secondary-transparent text-secondary">
                                                <FaCalendarCheck />
                                            </div>
                                            <div className="card-content">
                                                <span className="d-block fs-16 mb-5">Total Holidays</span>
                                                <h2 className="mb-5">{totalHolidays}</h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-xxl-4 col-xl-8 col-lg-8">
                                    <div className="card">
                                        <div className="card-header justify-between">
                                            <h4 className="">Recently Added Employees</h4>
                                            <a className="btn btn-primary-light btn-sm text-primary" href="javascript:void(0);">View All</a>
                                        </div>
                                        <div className="card-body pt-15">
                                            <div className="table-responsive">
                                                <table className="table tbody-b-none text-nowrap">
                                                    <thead>
                                                        <tr>
                                                            <th>Employee</th>
                                                            <th>Position</th>
                                                            <th>Department</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {recentlyAddedEmployees.map((employee, index) => (
                                                            <tr key={index}>
                                                                <td>
                                                                    <div className="d-flex-items gap-10">

                                                                        <h6>{`${employee.first_name} ${employee.last_name}`}</h6>
                                                                    </div>
                                                                </td>
                                                                <td>{employee.position}</td>
                                                                <td>{employee.department?.name || employee.department || 'N/A'}</td>
                                                                <td>
                                                                    <div className="d-flex-items gap-10">
                                                                        <a className="btn-icon btn-success-light" href={`/hr/employee/${employee.id}`}>
                                                                            <RiEyeLine />
                                                                        </a>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        {recentlyAddedEmployees.length === 0 && (
                                                            <tr>
                                                                <td colSpan="4" className="text-center">No recently added employees found</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xxl-3 col-xl-4 col-lg-4">
                                    <div className="d-flex flex-column">
                                        <div className="holiday-card">
                                            <h5 className="text-body text-center mb-15">Next Holiday</h5>
                                            <h3 className="text-body mb-5">{nextHoliday.name}</h3>
                                            <span className="text-body-secondary d-block">{formatDate(nextHoliday.date)}</span>
                                        </div>
                                    </div>
                                    <div className="d-flex flex-column">
                                        <div className="card">
                                            {dashboardData?.employees_born_today?.length > 0 ? (
                                                <ul className="list-group list-group-flush">
                                                    {dashboardData?.employees_born_today?.map((emp) => (
                                                        <li key={emp.id} className="list-group-item d-flex align-items-center border-0 px-0">
                                                            <div className="avatar avatar-md radius-100 bg-primary-transparent text-primary me-3 text-uppercase">
                                                                {emp.first_name[0]}{emp.last_name[0]}
                                                            </div>
                                                            <div className="flex-grow-1">
                                                                <h6 className="mb-0">{emp.first_name} {emp.last_name}</h6>
                                                                <span className="text-muted fs-12">{emp.position} - {emp.department.name}</span>
                                                            </div>
                                                            <span className="badge bg-label-primary">Happy Birthday!</span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            ) : (
                                                <p className="text-muted mb-0">No birthdays today.</p>
                                            )}
                                        </div>

                                    </div>
                                </div>

                                <div className="col-xxl-4 col-xl-12">
                                    <div className="card">
                                        <div className="card-header justify-between">
                                            <h4 className="">Recent Notice</h4>
                                            <div className="card-dropdown">
                                                <div className="dropdown">
                                                    <span className="card-dropdown-icon" aria-expanded="false">
                                                        <FaBell />
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body pt-15">
                                            <div className="announcement-list card-scrollbar">
                                                {recentNotices && recentNotices.length > 0 ? (
                                                    recentNotices.map((notice, index) => {
                                                        const colors = ['bg-primary', 'bg-secondary', 'bg-primary', 'bg-secondary', 'bg-primary'];
                                                        const color = colors[index % colors.length];
                                                        return (
                                                            <div key={notice.id || index} className="announcement-item">
                                                                <div className={`bullet ${color} mt-5`} />
                                                                <div className="announcement-content">
                                                                    <div className="announcement-header d-flex-between mb-10">
                                                                        <h5>{notice.title}</h5>
                                                                        <span className="fs-12 text-muted">{notice.created_at ? formatDate(notice.created_at) : ''}</span>
                                                                    </div>
                                                                    <p className="mb-15">{notice.content}</p>
                                                                    <div className="announcement-footer d-flex-between">
                                                                        <span className="fs-12 text-body-secondary">To: {notice.recipient_type || 'All'}</span>
                                                                        <div className="announcement-tags d-flex gap-10">
                                                                            <span className="badge bg-label-primary">{notice.recipient_type}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    })
                                                ) : (
                                                    <div className="text-center py-4">
                                                        <span className="text-muted">No recent notices found</span>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="announcement-view-btn">
                                                <a href="/hr/notices" className="btn btn-primary w-100">View All Notices</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="col-xxl-8 col-xl-12">
                                    <div className="card">
                                        <div className="card-header justify-between">
                                            <h4 className="">Leave Request</h4>
                                            <a className="btn btn-primary-light btn-sm text-primary" href="javascript:void(0);">View All</a>
                                        </div>
                                        <div className="card-body pt-15">
                                            <div className="table-responsive">
                                                <table className="table tbody-b-none text-nowrap">
                                                    <thead>
                                                        <tr>
                                                            <th>Employee</th>
                                                            <th>Leave Type</th>
                                                            <th>Dates</th>
                                                            <th>Duration</th>
                                                            <th>Status</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <div className="d-flex-items gap-10">
                                                                    <div className="avatar avatar-xs radius-100">
                                                                        <img className="radius-100" src="assets/images/avatar/avatar-thumb-001.webp" alt="image not found" />
                                                                    </div>
                                                                    <h6>Sarah Johnson</h6>
                                                                </div>
                                                            </td>
                                                            <td>Annual Leave</td>
                                                            <td>Jun 15 - Jun 18, 2023</td>
                                                            <td>4 days</td>
                                                            <td><span className="badge bg-label-success">Approved</span>
                                                            </td>
                                                            <td>
                                                                <div className="d-flex-items gap-10">
                                                                    <a className="btn-icon btn-info-light" href="javascript:void(0);" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Details">
                                                                        <i className="ri-eye-line" />
                                                                    </a>
                                                                    <a className="btn-icon btn-success-light" href="javascript:void(0);" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Approve">
                                                                        <i className="ri-check-line" />
                                                                    </a>
                                                                    <a className="btn-icon btn-danger-light" href="javascript:void(0);" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Reject">
                                                                        <i className="ri-close-line" />
                                                                    </a>
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td>
                                                                <div className="d-flex-items gap-10">
                                                                    <div className="avatar avatar-xs radius-100">
                                                                        <img className="radius-100" src="assets/images/avatar/avatar-thumb-002.webp" alt="image not found" />
                                                                    </div>
                                                                    <h6>Michael Chen</h6>
                                                                </div>
                                                            </td>
                                                            <td>Sick Leave</td>
                                                            <td>Jun 20 - Jun 21, 2023</td>
                                                            <td>2 days</td>
                                                            <td><span className="badge bg-label-warning">Pending</span>
                                                            </td>
                                                            <td>
                                                                <div className="d-flex-items gap-10">
                                                                    <a className="btn-icon btn-info-light" href="javascript:void(0);" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Details">
                                                                        <i className="ri-eye-line" />
                                                                    </a>
                                                                    <a className="btn-icon btn-success-light" href="javascript:void(0);" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Approve">
                                                                        <i className="ri-check-line" />
                                                                    </a>
                                                                    <a className="btn-icon btn-danger-light" href="javascript:void(0);" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Reject">
                                                                        <i className="ri-close-line" />
                                                                    </a>
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td>
                                                                <div className="d-flex-items gap-10">
                                                                    <div className="avatar avatar-xs radius-100">
                                                                        <img className="radius-100" src="assets/images/avatar/avatar-thumb-003.webp" alt="image not found" />
                                                                    </div>
                                                                    <h6>Emma Wilson</h6>
                                                                </div>
                                                            </td>
                                                            <td>Maternity Leave</td>
                                                            <td>Jul 1 - Sep 30, 2023</td>
                                                            <td>92 days</td>
                                                            <td><span className="badge bg-label-primary">In Review</span>
                                                            </td>
                                                            <td>
                                                                <div className="d-flex-items gap-10">
                                                                    <a className="btn-icon btn-info-light" href="javascript:void(0);" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Details">
                                                                        <i className="ri-eye-line" />
                                                                    </a>
                                                                    <a className="btn-icon btn-success-light" href="javascript:void(0);" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Approve">
                                                                        <i className="ri-check-line" />
                                                                    </a>
                                                                    <a className="btn-icon btn-danger-light" href="javascript:void(0);" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Reject">
                                                                        <i className="ri-close-line" />
                                                                    </a>
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td>
                                                                <div className="d-flex-items gap-10">
                                                                    <div className="avatar avatar-xs radius-100">
                                                                        <img className="radius-100" src="assets/images/avatar/avatar-thumb-004.webp" alt="image not found" />
                                                                    </div>
                                                                    <h6>David Kim</h6>
                                                                </div>
                                                            </td>
                                                            <td>Unpaid Leave</td>
                                                            <td>Jun 25 - Jun 30, 2023</td>
                                                            <td>6 days</td>
                                                            <td><span className="badge bg-label-danger">Rejected</span></td>
                                                            <td>
                                                                <div className="d-flex-items gap-10">
                                                                    <a className="btn-icon btn-info-light" href="javascript:void(0);" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Details">
                                                                        <i className="ri-eye-line" />
                                                                    </a>
                                                                    <a className="btn-icon btn-success-light" href="javascript:void(0);" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Approve">
                                                                        <i className="ri-check-line" />
                                                                    </a>
                                                                    <a className="btn-icon btn-danger-light" href="javascript:void(0);" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Reject">
                                                                        <i className="ri-close-line" />
                                                                    </a>
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td>
                                                                <div className="d-flex-items gap-10">
                                                                    <div className="avatar avatar-xs radius-100">
                                                                        <img className="radius-100" src="assets/images/avatar/avatar-thumb-005.webp" alt="image not found" />
                                                                    </div>
                                                                    <h6>Priya Patel</h6>
                                                                </div>
                                                            </td>
                                                            <td>Emergency Leave</td>
                                                            <td>Jul 5 - Jul 6, 2023</td>
                                                            <td>2 days</td>
                                                            <td><span className="badge bg-label-warning">Pending</span>
                                                            </td>
                                                            <td>
                                                                <div className="d-flex-items gap-10">
                                                                    <a className="btn-icon btn-info-light" href="javascript:void(0);" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Details">
                                                                        <i className="ri-eye-line" />
                                                                    </a>
                                                                    <a className="btn-icon btn-success-light" href="javascript:void(0);" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Approve">
                                                                        <i className="ri-check-line" />
                                                                    </a>
                                                                    <a className="btn-icon btn-danger-light" href="javascript:void(0);" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Reject">
                                                                        <i className="ri-close-line" />
                                                                    </a>
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td>
                                                                <div className="d-flex-items gap-10">
                                                                    <div className="avatar avatar-xs radius-100">
                                                                        <img className="radius-100" src="assets/images/avatar/avatar-thumb-006.webp" alt="image not found" />
                                                                    </div>
                                                                    <h6>Robert Garcia</h6>
                                                                </div>
                                                            </td>
                                                            <td>Work From Home</td>
                                                            <td>Jul 10 - Jul 14, 2023</td>
                                                            <td>5 days</td>
                                                            <td><span className="badge bg-label-success">Approved</span>
                                                            </td>
                                                            <td>
                                                                <div className="d-flex-items gap-10">
                                                                    <a className="btn-icon btn-info-light" href="javascript:void(0);" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Details">
                                                                        <i className="ri-eye-line" />
                                                                    </a>
                                                                    <a className="btn-icon btn-success-light" href="javascript:void(0);" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Approve">
                                                                        <i className="ri-check-line" />
                                                                    </a>
                                                                    <a className="btn-icon btn-danger-light" href="javascript:void(0);" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Reject">
                                                                        <i className="ri-close-line" />
                                                                    </a>
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td>
                                                                <div className="d-flex-items gap-10">
                                                                    <div className="avatar avatar-xs radius-100">
                                                                        <img className="radius-100" src="assets/images/avatar/avatar-thumb-007.webp" alt="image not found" />
                                                                    </div>
                                                                    <h6>Lisa Wong</h6>
                                                                </div>
                                                            </td>
                                                            <td>Half-day Leave</td>
                                                            <td>Jul 12, 2023 (PM)</td>
                                                            <td>Half day</td>
                                                            <td><span className="badge bg-label-slateblue">Approved</span>
                                                            </td>
                                                            <td>
                                                                <div className="d-flex-items gap-10">
                                                                    <a className="btn-icon btn-info-light" href="javascript:void(0);" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Details">
                                                                        <i className="ri-eye-line" />
                                                                    </a>
                                                                    <a className="btn-icon btn-success-light" href="javascript:void(0);" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Approve">
                                                                        <i className="ri-check-line" />
                                                                    </a>
                                                                    <a className="btn-icon btn-danger-light" href="javascript:void(0);" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Reject">
                                                                        <i className="ri-close-line" />
                                                                    </a>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
                { /* app-content-area-end */}</>
        </div>
    )
}

export default HRDashboard